export const APP_VERSION = '2.0.1';
export const BUILD_DATE = new Date().toISOString();
